// Header
import React from 'react';
import Avatar from 'components/common/Avatar';
import Rating from 'components/common/Rating';
import Icon from 'components/common/Icon';
import Loader from 'components/common/Loader';
import styles from './Header.module.sass';
import { PublicProfileResponse } from 'types/profile';
import { getCreatorReferralUrl } from 'utils/creator';

export interface HeaderProps
  extends Partial<
    Pick<
      PublicProfileResponse,
      | 'creatorId'
      | 'profilePicture'
      | 'firstName'
      | 'lastName'
      | 'overallRating'
    >
  > {
  isLoading: boolean;
  showNavBar: boolean;
  trackCTAClick: (location: 'header' | 'footer bar') => void;
}

const Header: React.FC<HeaderProps> = ({
  creatorId,
  profilePicture,
  firstName,
  lastName,
  overallRating,
  isLoading,
  showNavBar,
}) => {
  const referralHref = getCreatorReferralUrl(creatorId || '');
  return (
    <div className={styles.headerContainer}>
      <section className={styles.floatingDots}>
        <div />
        <div />
        <div />
      </section>
      {showNavBar && (
        <div className={styles.navbar}>
          <a
            className={styles.logo}
            href={referralHref}
            target="_blank"
            rel="noreferrer"
          >
            <img
              height={48}
              width={100}
              src="/images/trend-logo-black.svg"
              alt="trend-logo"
            />
          </a>
          <div className={styles.availability}>
            <span className={styles.shieldContainer}>
              <Icon name="verified-shield" size={32} color="neutral00" />
            </span>
            <div className={styles.availabilityText}>
              <p>Current availability:</p>
              <p>Ready for hire</p>
            </div>
          </div>
        </div>
      )}
      <div className={styles.header}>
        <div className={styles.avatarContainer}>
          {isLoading ? (
            <div className={styles.contentLoading}>
              <Loader />
            </div>
          ) : (
            <Avatar
              type="square"
              className={styles.avatar}
              src={profilePicture}
            />
          )}
          <div className={styles.nameRatingContainer}>
            <p>
              {firstName} {lastName}
            </p>
            <Rating rating={overallRating} />
          </div>
        </div>
        <div className={styles.headerContent}>
          <div className={styles.nameRatingContainer}>
            <p>
              {firstName} {lastName}
            </p>
            <Rating rating={overallRating} />
          </div>
          <h1>I help brands by shooting custom photos & videos</h1>
          <p className={styles.networkText}>
            Explore Trend's private network to get personalized, custom photos
            and videos for your business that will scale your sales.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Header;
